export default (state) => state.sort.name



/** WEBPACK FOOTER **
 ** ./app/selectors/currentSortColumn.js
 **/